import { render, staticRenderFns } from "./dialog-restore.vue?vue&type=template&id=5f8343ce&"
import script from "./dialog-restore.vue?vue&type=script&lang=js&"
export * from "./dialog-restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports